var app = angular.module("leonardo");

var BroadcastChannelService = function($timeout) {
  var service = {
    broadcastChannel: null,
    listeners: []
  };

  service.init = function () {
    service.broadcastChannel = window.BroadcastChannel ? new window.BroadcastChannel('leonardo') : null;
    if (!service.broadcastChannel) {
      return;
    }

    service.broadcastChannel.onmessage = function (ev) {
      if (!ev.isTrusted) return;
      angular.forEach(service.listeners, function (listener) {
        if (listener.onBroadcastChannelMessage) {
          $timeout(() => {
            listener.onBroadcastChannelMessage(ev.data);
          }, 10);
        }
      });
    };
  };

  service.subscribe = function (listener) {
    service.listeners.push(listener);
  };

  service.postMessage = function (message) {
    if (!service.broadcastChannel) return;
    service.broadcastChannel.postMessage(message);
  };

  service.init();

  return service;
};

app.factory('BroadcastChannelService', ['$timeout', BroadcastChannelService]);